import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgMinusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M19.2505 11.2504C19.6646 11.2505 20.0005 11.5863 20.0005 12.0004C20.0003 12.4143 19.6644 12.7502 19.2505 12.7504H4.75049C4.33638 12.7504 4.00066 12.4144 4.00049 12.0004C4.00049 11.5862 4.33628 11.2504 4.75049 11.2504H19.2505Z"
            fill="#5F47F6"
        />
    </svg>
);

export const MinusIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgMinusIcon}
        fontSize={fontSize}
    />
);
